<template>
    <div>
        <limitless-page-header
            :title="page_title"
            :sub-title="page_sub_title"
        ></limitless-page-header>

        <div class="content">
            <div class="content" v-if="loading">
                <i class="icon-spinner2 spinner"></i>
            </div>
            <div v-else-if="errors">
                <div
                    v-for="(fieldError, field) in errors"
                    :key="'errors-' + field"
                    class="alert alert-danger"
                >
                    {{ field }}: {{ fieldError[0] }}
                </div>
            </div>
            <div v-else-if="multi_response">
                <div
                    v-for="(order, o_index) in multi_response.orders"
                    :key="'result-' + o_index"
                    class="alert"
                    :class="{ 'alert-success': order.result, 'alert-danger': !order.result }"
                >
                    <div>{{ (order.type === 'prod_order' ? 'ProdOrder' : (order.type === 'return_order' ? 'ReturnOrder' : 'Order')) }} #{{ order.id }} ({{ order.card_uid }}): {{ order.message }}</div>
                    <div v-if="order.extra_message">{{ order.extra_message }}</div>
                </div>
            </div>
            <div v-else-if="print_response">
                <div v-if="print_response.printed" class="alert alert-success"><b>✓ Utskrift påbörjad</b></div>
                <div v-else class="alert alert-danger"><b>X Ej utskriven:</b> {{ print_response.message }}</div>
                <div
                    v-for="(order, o_index) in print_response.shipments"
                    :key="'result-' + o_index"
                    class="alert"
                    :class="{ 'alert-success': order.printed, 'alert-danger': !order.printed }"
                >
                    <div>{{ order.card_uid }}: {{ order.message }}</div>
                    <div v-if="order.extra_message">{{ order.extra_message }}</div>
                </div>
            </div>
            <div v-else-if="!sent_to_printer && !search_on_init">
                <div style="max-width: 500px;">
                    <div class="form-group">
                        <div class="custom-control custom-radio mb-2">
                            <input type="radio" class="custom-control-input" name="sok" id="sok-card" v-model="listType" value="carduid">
                            <label class="custom-control-label" for="sok-card">Kortnummer</label>
                        </div>
                        <div class="custom-control custom-radio mb-3">
                            <input type="radio" class="custom-control-input" name="sok" id="sok-parcel" v-model="listType" value="parcel">
                            <label class="custom-control-label" for="sok-parcel">Kollinummer</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{ (listType === 'parcel' ? 'Kollinummer' : 'Kortnummer') }}</label>
                        <textarea
                            rows="10"
                            required
                            class="form-control"
                            :placeholder="(listType === 'parcel' ? 'Kollinummer' : 'Kortnummer')"
                            v-model="listInput"
                        ></textarea>
                    </div>
                    <button type="button" class="btn btn-primary" @click="search">Sök</button>
                </div>
            </div>
            <div v-else-if="!sent_to_printer">
                <div class="row">
                    <div v-if="show_print" class="col-lg-6">
                        <div class="card">
                            <div class="card-header bg-white">
                                <h6 class="card-title">
                                    SKRIV UT
                                    <span v-if="filter.print_letter">BREVETIKETTER</span>
                                    <span v-else>FRAKTSEDLAR</span>
                                </h6>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-auto form-group">
                                        <div class="custom-control custom-control-inline custom-radio">
                                            <input type="radio" class="custom-control-input" name="print_letter" id="chk-print_freightlabel" v-model="filter.print_letter" :value="false">
                                            <label class="custom-control-label" for="chk-print_freightlabel">Fraktsedlar</label>
                                        </div>
                                        <div class="custom-control custom-control-inline custom-radio">
                                            <input type="radio" class="custom-control-input" name="print_letter" id="chk-print_letter" v-model="filter.print_letter" :value="true">
                                            <label class="custom-control-label" for="chk-print_letter">Brevetiketter</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-auto flex-grow-1 d-flex">
                                        <div class="col-form-label pr-1">Välj skrivare:</div>
                                        <div class="flex-grow-1">
                                            <select-with-validation
                                                v-if="filter.print_letter"
                                                option-label="name"
                                                :options="smalllabel_printers"
                                                vid="printer_tag"
                                                label="Skrivare"
                                                v-model="printer_tag"
                                                :reduce="opt => opt.tag"
                                                placeholder="-- Välj skrivare --"
                                                :disabled="loading"
                                                hide-label
                                            >
                                            </select-with-validation>
                                            <select-with-validation
                                                v-else
                                                vid="printer_tag"
                                                label="Skrivare"
                                                v-model="printer_tag"
                                                :reduce="opt => opt.tag"
                                                placeholder="-- Välj skrivare --"
                                                :disabled="loading"
                                                component="label-printer-filter"
                                                hide-label
                                            >
                                            </select-with-validation>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <limitless-button
                                            :busy="loading"
                                            icon="icon-printer2"
                                            @click="printBatch"
                                        >
                                            SKRIV UT
                                            <span v-if="filter.print_letter">BREVETIKETTER</span>
                                            <span v-else>FRAKTSEDLAR</span>
                                        </limitless-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="custom-control custom-control-inline custom-checkbox mb-3">
                                            <input type="checkbox" class="custom-control-input" id="chk-default-printer" v-model="set_as_defualt_printer">
                                            <label class="custom-control-label" for="chk-default-printer">Sätt vald skrivare som standardskrivare på denna dator</label>
                                        </div>
                                    </div>
                                    <div v-if="filter.print_letter" class="col-lg-6">
                                        <div class="custom-control custom-control-inline custom-checkbox mb-3">
                                            <input type="checkbox" class="custom-control-input" id="chk-set_status" v-model="set_status">
                                            <label class="custom-control-label" for="chk-set_status">Sätt status till 500 Levererad</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="show_comment" class="col-lg-6">
                        <div class="card">
                            <div class="card-header bg-white header-elements-inline">
                                <h6 class="card-title">MULTIKOMMENTAR</h6>
                                <div class="header-elements">
                                    <button type="button" class="btn btn-light" @click="addLink">Lägg in byteslänk</button>
                                </div>
                            </div>
                            <div class="card-body">
                                <form @submit="saveComment">
                                    <ValidationObserver ref="multicommentform">
                                        <div class="form-group">
                                            <textarea-with-validation
                                                label="Kommentar"
                                                v-model="multi.comment"
                                                :rows="4"
                                                :placeholder="((!multi.send_email && !multi.send_sms) ? 'Skriv en kommentar...' : 'Skriv ett meddelande...')"
                                                :disabled="saving_comment"
                                                rules="required"
                                                hide-label
                                            ></textarea-with-validation>
                                        </div>
                                        <div v-if="show_externalmessage">
                                            <div class="form-group">
                                                <ValidationProvider vid="TimeIN_date" name="Start datum" rules="" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <v-date-picker v-model="multi.wanted_delivery_date" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }">
                                                            <template v-slot="{ inputValue, togglePopover }">
                                                                <label>Nytt leveransdatum<span class="text-muted"> (lämna tomt för att inte ändra)</span></label>
                                                                <div class="input-group">
                                                                    <input class="form-control" :value="inputValue" @focus="togglePopover()" placeholder="Nytt leveransdatum">
                                                                    <span class="input-group-append">
                                                                    <button class="btn btn-light" type="button" @click="multi.wanted_delivery_date = ''"><i class="icon-cross3"></i></button>
                                                                </span>
                                                                </div>
                                                            </template>
                                                        </v-date-picker>
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                            <div class="form-group">
                                                <div class="custom-control custom-checkbox mb-1">
                                                    <input type="checkbox" class="custom-control-input" name="contact_type" id="chk-send-internal" :checked="!multi.send_email && !multi.send_sms" disabled>
                                                    <label class="custom-control-label" for="chk-send-internal">Endast intern kommentar</label>
                                                </div>
                                                <div class="custom-control custom-checkbox mb-1">
                                                    <input type="checkbox" class="custom-control-input" name="contact_type" id="chk-send-email" v-model="multi.send_email" :disabled="saving_comment">
                                                    <label class="custom-control-label" for="chk-send-email">Skicka ovanstående meddelande som EPOST till inlösaren</label>
                                                </div>
                                                <div class="custom-control custom-checkbox mb-1">
                                                    <input type="checkbox" class="custom-control-input" name="contact_type" id="chk-send-sms" v-model="multi.send_sms" :disabled="saving_comment">
                                                    <label class="custom-control-label" for="chk-send-sms">Skicka ovanstående meddelande som SMS till inlösaren</label>
                                                </div>
                                            </div>
                                            <div class="alert alert-secondary mb-3" v-if="multi.send_sms">
                                                <i class="icon-info3"></i>
                                                <span v-if="multi.send_email">Meddelandet skickas i första hand som E-post, om ingen adress finns testas SMS, annars kommer det ut på fellistan för manuell hantering.</span>
                                                Försök hålla texten kort så det får plats i 1st SMS.
                                            </div>
                                            <div v-if="multi.send_sms" style="font-size: 12px;" class="text-muted mb-3">
                                                <div>Antal SMS: {{ sms_count.messages }}</div>
                                                <div>Encoding: {{ sms_count.encoding }}</div>
                                                <div>Antal tecken kvar: {{ sms_count.remaining }}</div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="form-group" v-if="hasRole('super-admin')">
                                                <div class="custom-control custom-radio mb-1">
                                                    <input type="radio" class="custom-control-input" name="status_id" id="chk-s-null" :value="null" v-model="multi.status_id" :disabled="saving_comment">
                                                    <label class="custom-control-label" for="chk-s-null">Ingen statusändring, endast intern kommentar</label>
                                                </div>
                                                <div v-for="(status, s_index) in statuses" class="custom-control custom-radio mb-1" :key="'chk-s-' + s_index + '-' + status.id">
                                                    <input type="radio" class="custom-control-input" name="status_id" :id="'chk-s-' + status.id" :value="status.id" v-model="multi.status_id" :disabled="saving_comment">
                                                    <label class="custom-control-label" :for="'chk-s-' + status.id">Ändra till status {{ status.id }}, {{ status.name }}</label>
                                                </div>
                                            </div>
                                            <div class="form-group" v-else>
                                                <div class="custom-control custom-radio mb-1">
                                                    <input type="radio" class="custom-control-input" name="status_id" id="chk-s-null" :value="null" v-model="multi.status_id" :disabled="saving_comment">
                                                    <label class="custom-control-label" for="chk-s-null">Ingen statusändring, endast intern kommentar</label>
                                                </div>
                                                <div class="custom-control custom-radio mb-1">
                                                    <input type="radio" class="custom-control-input" name="status_id" id="chk-s-590" :value="590" v-model="multi.status_id" :disabled="saving_comment">
                                                    <label class="custom-control-label" for="chk-s-590">Nedanstående kollin är returer, status: 590 - Retur PostNord</label>
                                                </div>
                                                <div class="custom-control custom-radio mb-1">
                                                    <input type="radio" class="custom-control-input" name="status_id" id="chk-s-350" :value="350" v-model="multi.status_id" :disabled="saving_comment">
                                                    <label class="custom-control-label" for="chk-s-350">Nedanstående kollin är packade, status: 350 - Packad</label>
                                                </div>
                                                <div class="custom-control custom-radio mb-1">
                                                    <input type="radio" class="custom-control-input" name="status_id" id="chk-s-250" :value="250" v-model="multi.status_id" :disabled="saving_comment">
                                                    <label class="custom-control-label" for="chk-s-250">Nedanstående kollin är rivna, status: 250 - Restprodukt, Väntar</label>
                                                </div>
                                                <div class="custom-control custom-radio mb-1">
                                                    <input type="radio" class="custom-control-input" name="status_id" id="chk-s-70" :value="70" v-model="multi.status_id" :disabled="saving_comment">
                                                    <label class="custom-control-label" for="chk-s-70">Nedanstående kollin är rivna, status: 70 - Lapp riven</label>
                                                </div>
                                            </div>
                                        </div>
                                        <limitless-button :busy="saving_comment" :icon="save_comment_icon" @click="saveComment" ref="btnsavecomment">{{ save_comment_button }}</limitless-button>
                                    </ValidationObserver>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <rednax-datatable
                        ref="batchtable"
                        :url="'/vue/batch/list'"
                        :columns="table_columns"
                        :filter="filter"
                        sort-by="OrderTS"
                        sort-order="desc"
                        @rowclick="rowClick"
                        :per-page="10000"
                    >
                        <template #cell_CardUID="{ row }">
                            <router-link v-if="row.ReturnOrderID" :to="{ name: 'returnorder.edit', params: { id: row.ReturnOrderID } }" class="d-block">{{ row.CardUID }}</router-link>
                            <router-link v-else :to="{ name: 'prodorders.edit', params: { id: (row.ProdOrderID > 0 ? row.ProdOrderID : 0) }, query: { card_no: row.CardUID } }" class="d-block">{{ row.CardUID }}</router-link>
                            <div v-if="row.IsDeliverable" class="badge badge-success">Flaggad som levererbar</div>
                            <div v-else-if="row.IsDeliverable != null" class="badge badge-danger">EJ levererbar</div>
                        </template>
                        <template #cell_StatusID="{ row }">
                            <div v-if="row.StatusDate">{{ row.StatusDate }}</div>
                            <div
                                class="badge"
                                :class="[row.StatusClass ? 'badge-' + row.StatusClass : 'badge-secondary']"
                                v-if="row.ProdOrderID > 0 || row.ReturnOrderID > 0"
                            >
                                <span v-if="row.ProdOrderID > 0 && row.StatusID === 0">Inlöst</span>
                                <span v-else>{{ row.StatusName ? row.StatusName : row.StatusID }}</span>
                            </div>
                        </template>
                        <template #cell_WantedDeliveryDate="{ row }">
                            {{ row.WantedDeliveryDate }}<div v-if="row.DeliveryASAP" class="badge badge-teal ml-2">ASAP</div>
                        </template>
                        <template #cell_OrderID="{ row }">
                            <router-link v-if="row.OrderID" :to="{ name: 'cardorders.edit', params: { id: row.OrderID } }">#{{ row.OrderID }}</router-link>
                        </template>
                        <template #cell_CompanyName="{ row }">
                            <router-link v-if="row.CompanyName && row.CustomerID" :to="{ name: 'customers.edit', params: { id: row.CustomerID } }">{{ row.CompanyName }}</router-link>
                        </template>
                        <template #cell_json_products="{ row }">
                            <div
                                v-for="(prod_name, prod_id) in row.json_products"
                                :key="'jp-' + row.OrderID + '-' + prod_id"
                            >
                                <router-link :to="{ name: 'products.purchases', params: { id: prod_id } }">{{ prod_name }}</router-link>
                            </div>
                        </template>
                    </rednax-datatable>
                </div>
            </div>
            <div v-else class="alert alert-danger"><b>X Ej utskriven:</b> Något gick fel....</div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import getError from '@services/ErrorHelper';
import Cookies from 'js-cookie';
import SelectWithValidation from '@components/Form/SelectWithValidation';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent.vue';
import DeliveryTypeRepository from '@services/repositories/DeliveryTypeRepository';
import { keyBy } from 'lodash';
import { formatDateTime, getUrlParameters, hasRole } from '@services/Helpers';
import TextareaWithValidation from '@components/Form/TextareaWithValidation.vue';
import { count } from 'sms-length';
import BackendRepository from '@services/repositories/BackendRepository';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import { useLayoutHandlerStore } from '@services/pinia/LayoutHandlerStore';
import { mapActions } from 'pinia';

export default {
    name: 'NtapsBatchPrint',
    components: {
        VDatePicker,
        TextareaWithValidation,
        RednaxDatatable,
        LimitlessButton,
        SelectWithValidation,
        LimitlessPageHeader,
    },
    data: () => ({
        set_as_defualt_printer: false,
        loading: false,
        saving_comment: false,
        sent_to_printer: false,
        print_response: null,
        multi_response: null,
        errors: null,
        printer_tag: null,
        listType: 'carduid',
        listInput: '',
        smalllabel_printers: [],
        multi: {
            comment: '',
            status_id: null,
            send_sms: false,
            send_email: false,
            wanted_delivery_date: '',
            source: null,
        },
        statuses: [],
        filter: {},
        set_status: true,
        product: null,
    }),
    created() {
        this.getStatuses();
        this.getPrinters();
        this.getDeliveryTypes();
        const printerTag = Cookies.get('freightlabel_printer');
        if (printerTag) {
            this.printer_tag = printerTag;
        }
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const func = urlParams.get('func');
        if (func === 'contact') {
            this.setActiveTag('multi-comment-customerservice');
        } else if (func === 'comment') {
            this.setActiveTag('multi-comment-warehouse');
        } else {
            this.setActiveTag('ntaps-label-form');
        }

        const filter = getUrlParameters();
        if (!Object.hasOwn(filter, 'print_letter')) {
            filter.print_letter = false;
        }

        this.filter = filter;

        if (filter.prod_id) {
            this.getProduct(filter.prod_id);
        }
    },
    watch: {
        'filter.print_letter': function watchPrintLetter(newVal) {
            if (newVal) {
                const printerTag = Cookies.get('small_label_printer');
                if (printerTag) {
                    this.printer_tag = printerTag;
                } else {
                    this.printer_tag = null;
                }
            } else {
                const printerTag = Cookies.get('freightlabel_printer');
                if (printerTag) {
                    this.printer_tag = printerTag;
                } else {
                    this.printer_tag = null;
                }
            }
        },
    },
    methods: {
        hasRole,
        ...mapActions(useLayoutHandlerStore, ['setActiveTag']),
        async printBatch() {
            if (this.printer_tag) {
                this.loading = true;
                if (this.set_as_defualt_printer) {
                    if (this.filter.print_letter) {
                        Cookies.set('small_label_printer', this.printer_tag, { expires: 365 });
                        this.set_as_defualt_printer = false;
                    } else {
                        Cookies.set('freightlabel_printer', this.printer_tag, { expires: 365 });
                        this.set_as_defualt_printer = false;
                    }
                }
                await apiClient.post('/vue/batch/print', {
                    ...this.filter,
                    printer_tag: this.printer_tag,
                    no_statuschange: (this.filter.print_letter && !this.set_status),
                })
                    .then((response) => {
                        this.sent_to_printer = true;
                        this.print_response = response.data;
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.errors = parsederror;
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        async saveComment() {
            const isValid = await this.$refs.multicommentform.validate();
            if (isValid) {
                this.saving_comment = true;
                await apiClient.post('/vue/batch/multicomment', { multi: { ...this.multi }, ...this.filter })
                    .then((response) => {
                        this.multi_response = response.data;
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.errors = parsederror;
                        }
                        this.$refs.btnsavecomment.triggerFailed();
                    })
                    .finally(() => {
                        this.saving_comment = false;
                    });
            }
        },
        getDeliveryTypes() {
            const client = new DeliveryTypeRepository();
            client.getAll().then((res) => {
                this.delivery_types = keyBy(res, 'id');
            });
        },
        rowClick(data, event) {
            let url = '/prodorders/' + (data.ProdOrderID > 0 ? data.ProdOrderID : 0) + '?card_no=' + data.CardUID;
            if (this.filter.type === 'return_order') {
                url = '/returnorders/' + data.ReturnOrderID;
            }
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open(url).focus();
            } else {
                window.location.href = url;
            }
        },
        search() {
            const separateLines = this.listInput.split(/\r?\n|\r|\n/g).filter((str) => str.length > 0);
            let func = '';
            if (this.filter.func) {
                func = '&func=' + this.filter.func;
            }
            if (separateLines.length > 0) {
                window.location.href = '/batch/list?type=' + this.listType + func + '&' + separateLines.map((line) => 'ids[]=' + line).join('&');
            }
        },
        addLink() {
            this.multi.comment += ' https://www.ordergift.se/%%CARDNUMBER%%';
        },
        getStatuses() {
            BackendRepository.getStatuses().then((res) => {
                this.statuses = res.filter((s) => [0, 70, 80, 250, 300, 350, 399, 400, 500, 510, 590].includes(s.id));
            });
        },
        getPrinters() {
            BackendRepository.getSmallLabelPrinters().then((printers) => {
                this.smalllabel_printers = printers.filter((p) => p.media === 'adr_99x49');
            });
        },
        getProduct(prodId) {
            apiClient.get('/vue/products/' + prodId + '/info').then((response) => {
                this.product = response.data.product;
                if (response.data.product.sendByMail) {
                    this.filter.print_letter = true;
                }
            }).catch(() => {
                this.product = null;
            });
        },
    },
    computed: {
        search_on_init() {
            if (!this.filter.type) {
                return false;
            }
            if (Object.keys(this.filter).filter((f) => f !== 'type').length > 0) {
                return true;
            }
            return false;
        },
        show_print() {
            if (this.filter.func && this.filter.func !== 'print') {
                return false;
            }
            return true;
        },
        show_comment() {
            if (this.filter.func && (this.filter.func === 'comment' || this.filter.func === 'contact')) {
                return true;
            }
            return false;
        },
        show_externalmessage() {
            if (this.filter.func && this.filter.func === 'contact') {
                return true;
            }
            return false;
        },
        save_comment_button() {
            return ((this.multi.send_email || this.multi.send_sms) ? 'Skicka meddelande' : 'Spara kommentar' + (this.multi.status_id ? ' och uppdatera status' : ''));
        },
        save_comment_icon() {
            return ((this.multi.send_email || this.multi.send_sms) ? 'icon-paperplane' : 'icon-floppy-disk');
        },
        page_title() {
            if (this.filter.func === 'print') {
                return 'Batchutskrift';
            }
            if (this.filter.func === 'contact') {
                return 'Multikommentar';
            }
            if (this.filter.func === 'comment') {
                return 'Multikommentar/-statusändring';
            }
            return 'Batchutskrift/Multikommentar/-statusändring';
        },
        page_sub_title() {
            if (!this.sent_to_printer && !this.search_on_init) {
                return null;
            }
            return (this.filter.type === 'return_order' ? 'Returnorder' : 'Prodorder');
        },
        old_system_url() {
            return window.config.app.old_system_url;
        },
        sms_count() {
            return count(this.multi.comment);
        },
        table_columns() {
            const vm = this;
            const columns = [];

            if (this.filter.type === 'parcel') {
                columns.push({
                    header: 'Ordertyp',
                    data: 'order_type',
                    sortable: false,
                });
            }
            if (this.filter.type === 'card_order_delivery_address') {
                columns.push({
                    header: 'Kontakt',
                    data: 'Name',
                    sortable: false,
                });
            } else {
                columns.push({
                    header: 'Kortnummer',
                    data: 'CardUID',
                    sortable: false,
                });
                columns.push({
                    header: 'Status',
                    data: 'StatusID',
                    sortable: false,
                });
                columns.push({
                    header: 'Inlöst av',
                    data: 'Name',
                    sortable: false,
                    render(row) {
                        return (row.ProdOrderID > 0 ? row.Name + (row.Company ? ', ' + row.Company : '') : '');
                    },
                });
            }
            columns.push({
                header: 'Gata',
                data: 'Street',
                sortable: false,
            });
            columns.push({
                header: 'Postnummer',
                data: 'Zip',
                sortable: false,
                render(row) {
                    let str = '';
                    if (row.Zip) {
                        str += row.Zip;
                    }
                    if (row.City) {
                        str += (str ? ' ' : '') + row.City;
                    }
                    if (row.CountryCode) {
                        str += (str ? ', ' : '') + row.CountryCode;
                    }
                    return str;
                },
            });
            columns.push({
                header: 'Orderdatum',
                data: 'OrderTS',
                sortable: false,
                render(row) {
                    return formatDateTime(row.OrderTS);
                },
            });
            columns.push({
                header: 'Önskad leverans',
                data: 'WantedDeliveryDate',
                sortable: false,
            });
            columns.push({
                header: 'Leveranssätt',
                data: 'DeliveryType',
                sortable: false,
                render(row) {
                    return (vm.delivery_types[row.DeliveryType] ? vm.delivery_types[row.DeliveryType].label : row.DeliveryType);
                },
            });
            columns.push({
                header: 'Produkt(er)',
                data: 'json_products',
                sortable: false,
            });
            columns.push({
                header: 'Kortorder',
                data: 'OrderID',
                sortable: false,
            });
            columns.push({
                header: 'Kund',
                data: 'CompanyName',
                sortable: false,
            });

            return columns;
        },
    },
};
</script>
